export default "__VITE_PUBLIC_ASSET__22661149__"